export const isAdminUser = email =>
  [
    "shawn@layer3dev.com",
    "guadalupe@visionsmgmt.com",
    "admin@visions.com",
    "jordan@layer3dev.com",
    "daniel.lopez@holitna.com",
    "isaac.padilla@holitna.com",
    "ryan.dayal@holitna.com",
    "tiffany.masura@holitna.com",
  ].includes((email || "").toLowerCase());

export const permissions = {
  admin: 1,
  manager: 2,
  inventory: 3,
  billing_user: 4,
  client: 5,
  employee: 6,
  shopper: 7,
  viewer: 8,
};
